"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverPlacements = exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _container_prop_type = _interopRequireDefault(require("../portal/container_prop_type"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var deprecatedPlacements = ['left-end', 'left-start', 'left', 'right-end', 'right-start', 'right'];
var popoverPlacements = exports.popoverPlacements = [].concat(deprecatedPlacements, ['bottom-end', 'bottom-start', 'bottom', 'leading-end', 'leading-start', 'leading', 'top-end', 'top-start', 'top', 'trailing-end', 'trailing-start', 'trailing']);
var propTypes = {
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    getBoundingClientRect: _propTypes.default.func
  }), typeof Element === 'undefined' ? _propTypes.default.any : _propTypes.default.instanceOf(Element)]),
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  fixed: _propTypes.default.bool,
  flip: _propTypes.default.bool,
  id: _propTypes.default.string,
  keepMounted: _propTypes.default.bool,
  modifiers: _propTypes.default.array,
  onChangePlacement: _propTypes.default.func,
  open: _propTypes.default.bool,
  placement: function placement(props, propName, componentName) {
    var value = props[propName];
    if (!popoverPlacements.includes(value)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to") + " `".concat(componentName, "`. Validation failed."));
    }
    if (deprecatedPlacements.includes(value)) {
      var _value$split = value.split('-'),
        _value$split2 = _slicedToArray(_value$split, 2),
        first = _value$split2[0],
        last = _value$split2[1];
      var newPropValue = [first[0] === 'left' ? 'leading' : 'trailing', last].filter(Boolean).join('-');
      return new Error(["@veneer/core: The value `".concat(value, "` supplied to `").concat(componentName, ".").concat(propName, "` was deprecated."), "Use the placement `".concat(newPropValue, "` instead.")].join('\n'));
    }
    return null;
  },
  portal: _propTypes.default.bool,
  portalContainer: _container_prop_type.default,
  role: _propTypes.default.string,
  style: _propTypes.default.shape({}),
  transition: _propTypes.default.bool
};
var _default = exports.default = propTypes;